import { Component } from '@angular/core';

@Component({
  selector: 'app-aprovacao-resumo',
  templateUrl: './aprovacao-resumo.component.html',
  styleUrls: ['./aprovacao-resumo.component.scss']
})
export class AprovacaoResumoComponent {
  constructor() {}
}
